import { useRoutes } from 'react-router-dom';
import Layout from './components/Layout';
import AuthLayout from './components/AuthLayout';

import Home from './pages/Home';
import CopyrightHolders from './pages/CopyrightHolders';
import Advertise from './pages/Advertise';
import Login from './pages/Login';
import Register from './pages/Register';
import {
  Catalog,
  Profile,
  My,
  Top100,
  New,
  Ongoing,
  Genres,
  Countries,
  Bookmarks,
  History,
  Settings,
  Watch,
  Lakorns,
  TopUsers
} from './pages/Pages';

const AppRoutes = () => {
  const routes = useRoutes([
    {
      path: '/auth',
      element: <AuthLayout />,
      children: [
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
      ],
    },
    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: 'catalog', element: <Catalog /> },
        { path: 'profile', element: <Profile /> },
        { path: 'my', element: <My /> },
        { path: 'top-100', element: <Top100 /> },
        { path: 'new', element: <New /> },
        { path: 'ongoing', element: <Ongoing /> },
        { path: 'genres', element: <Genres /> },
        { path: 'countries', element: <Countries /> },
        { path: 'bookmarks', element: <Bookmarks /> },
        { path: 'history', element: <History /> },
        { path: 'settings', element: <Settings /> },
        { path: 'copyright', element: <CopyrightHolders /> },
        { path: 'advertise', element: <Advertise /> },
        { path: 'lakorns', element: <Lakorns /> },
        { path: 'top-users', element: <TopUsers /> },
        { path: 'dorama/:slugParam', element: <Watch /> }
      ],
    },
  ]);

  return routes;
};

export default AppRoutes;
